export const PATH = {
    HOME: "/",
    CONTACT:"/contact-us"
}

export default PATH;